import { axiosIns } from "../utils";

export const fetchAppelsOffres = async () => {
  const response = await axiosIns.get("/appel-offres/");
  return response && response.data ? response.data : response;
};

export const fetchAppelOffre = async (id) => {
  const response = await axiosIns.get(`/appel-offres/${id}/`);
  return response && response.data ? response.data : response;
};

export const createAppelOffreApi = async (formData) => {
  const response = await axiosIns.post("/appel-offres/", formData);
  return response && response.data ? response.data : response;
};

export const updateAppelOffreApi = async (id, formDataOrPayload) => {
  const response = await axiosIns.patch(
    `/appel-offres/${id}/`,
    formDataOrPayload
  );
  return response && response.data ? response.data : response;
};

export const publishAppelOffreApi = async (id) => {
  const response = await axiosIns.patch(`/appel-offres/${id}/publish/`);
  return response && response.data ? response.data : response;
};

export const deleteAppelOffreApi = async (id) => {
  const response = await axiosIns.delete(`/appel-offres/${id}/`);
  return response && response.data ? response.data : response;
};
